export default __webpack_public_path__ + "static/media/sv.885f06de.jpg";